import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { logout as logoutAction, IUser } from '../../store/user/UserActions';
import { Container, Col, Row } from 'reactstrap';

import NavBar from '../../components/NavBar';
interface PropsFromState {
    
    route: any
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    component: any
    logout: typeof logoutAction
    user: IUser
    userDB: any
    login: any
    logged: any
    editProfile: any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch


export default class PrivateLayout extends Component<AllProps> {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    componentWillUnmount(){
    }
    
    render() {
        const Component = this.props.component;
        const route = this.props.route;
        const user = this.props.user;
        const logout = this.props.logout;
        return (

            <Fragment>
                <NavBar
                    editProfileButtonMethod={this.props.editProfile}
                    userDB={this.props.userDB}
                    isAuthenticated={this.props.logged}
                    authButtonMethod={this.props.logged ? this.props.logout : this.props.login}
                    user={this.props.logged ? { name: user.fullName, displayName: user.fullName, email: user.emailAdd } : {}}
                ></NavBar>
                <main role="main">
                    <div className="container-fluid">
                        <Component route={route} />
                    </div>
                </main>
                <footer className="footer" style={{backgroundColor:"#45474C", color:"#ffffff", textAlign:"center", padding:"8px"}}>
                    <Row>
                        <Col>
                            <span className="" style={{fontSize:"smaller"}}>© Ultimates Pro Copyrights 2020</span>
                        </Col>
                    </Row>
                </footer>
            </Fragment>
        );
    }
}